export enum AnalyzeSettingsType {
  Energy = 'Energy',
  Flow = 'Flow',
  Temp = 'Temp',
  Effect = 'Effect',
  None = 'None',
  Economy = 'Economy'
}
